import * as React from "react";
const SvgArrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" {...props}>
    <path
      d="M280.859 1.095c-8.204 2.602-8.622 2.997-107.421 101.718L76.172 200l97.266 97.227c93.539 93.503 97.475 97.325 102.734 99.776 23.993 11.182 50.837-8.792 46.567-34.649-1.937-11.732 1.59-7.783-79.248-88.721L169.949 200l73.542-73.633c80.838-80.938 77.311-76.989 79.248-88.721 3.879-23.489-19.293-43.712-41.88-36.551"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);
export default SvgArrow;
